import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import { Grid, IconButton } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { GridViewOutlined } from '@mui/icons-material';
import { getQCReasonCheckBoxBorderProps } from 'components/Modals/QCPassFailModal/utilities';

export const QCReasonCheckbox = ({
  classes,
  check,
  handleCheckboxChanged,
  label,
  qcScore,
  isModelOverlayEnabled,
  handleModelOverlayClick,
  qcData,
  isGLP = false,
}) => {
  const modelScore = qcScore && Number(qcScore).toFixed(2);

  const { borderColor, borderSize } = getQCReasonCheckBoxBorderProps(
    modelScore,
    isGLP,
  );

  const isModelOverlayOptionVisible = !isGLP && qcData?.score !== undefined;
  const modelOverlayButtonStyles = useMemo(
    () => ({
      backgroundColor: isModelOverlayEnabled ? 'lightblue' : 'lightgray',
      marginRight: '0.5rem',
    }),
    [isModelOverlayEnabled],
  );

  const handleModelOverlayButtonClick = () => {
    handleModelOverlayClick(isModelOverlayEnabled);
  };

  return (
    <Box>
      <div className={classes.qcCheckFailContainer}>
        <Box
          border={borderSize}
          borderColor={borderColor}
          borderRadius={1}
          mt={1}
          className={classes.qcCheckFailContainer}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Checkbox
                checked={check}
                onChange={handleCheckboxChanged}
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />{' '}
              {label}
            </Grid>
            {isModelOverlayOptionVisible && (
              <Grid item>
                <IconButton
                  onClick={handleModelOverlayButtonClick}
                  size="small"
                  style={modelOverlayButtonStyles}
                  title="Model Overlay"
                >
                  <GridViewOutlined />
                </IconButton>
              </Grid>
            )}
          </Grid>
        </Box>
      </div>
    </Box>
  );
};
